import { shipmentStatusLabels } from '@reveni-io/reveni-ui'

import { alertTypes } from '@/parcels/constants'

export const getExceptionMessage = ({ exception, statusTime, t }) => {
  if (exception?.type === alertTypes.pickupCreationError) return t('Error en la recogida')

  if (exception?.type === alertTypes.statusStalled) {
    const current = new Date()
    const diff = current - new Date(statusTime)
    const days = Math.floor(diff / (1000 * 60 * 60 * 24))

    return t(`Envío marcado como "{{status}}" durante {{days}} días`, {
      status: t(shipmentStatusLabels[exception.properties.status]),
      days,
    })
  }
}
